$(window).on('load', function() {
  	$('.single-option-selector').select2({
      	minimumResultsForSearch: -1,
      	width: '100%',
        dropdownParent: $('.product-form__controls-group .selector-wrapper')
  	});
  	
  	$( ".bold_option_value label" ).click(function() {
 		setTimeout(function(){  
          	
          $('.bold_option_set .bold_option:nth-child(2) select, .bold_option_set .bold_option:nth-child(3) select').select2({
                minimumResultsForSearch: -1,
                width: '100%',
                tags: true,
                dropdownParent: $('.bold_option_set')
                
            }); 
          
         $(".bold_option_textbox .tb_1228033_494854").attr("placeholder", "Type Your Text Here");   
          
          	var $eventSelect = $('.bold_option_element');
          
			$eventSelect.on("select2:select", function (e) {
               // console.log($(this));
              if($(this)[0].children[0][0].innerText == '-- Choose Font --'){
                  var _id = e.params.data.id;   
                  var _InputAttr = $(".tb_1228033_494854");
                  var _Classes = _InputAttr.attr('class');
                  var arryCls = _Classes.split(" ");
                  if(arryCls[1]!=undefined && _InputAttr.hasClass(arryCls[1])){
                      _InputAttr.removeClass(arryCls[1]);	
                      _InputAttr.addClass(_id);
                  }else{
                      _InputAttr.addClass(_id);

                  }
               }
                         
			});
          
          	
 		}, 0);   	  
      
    });
  
    
 
  	
//--------------------//  
  
  
  
    jQuery('<div class="quantity-nav"><div class="quantity-button quantity-up">+</div><div class="quantity-button quantity-down">-</div></div>').insertAfter('.product-form__input--quantity');
    jQuery('.product-form__item').each(function() {
      var spinner = jQuery(this),
        input = spinner.find('input[type="number"]'),
        btnUp = spinner.find('.quantity-up'),
        btnDown = spinner.find('.quantity-down'),
        min = input.attr('min'),
        max = input.attr('max');

      btnUp.click(function() {
        var oldValue = parseFloat(input.val());
        if (oldValue >= max) {
          var newVal = oldValue;
        } else {
          var newVal = oldValue + 1;
        }
        spinner.find("input").val(newVal);
        spinner.find("input").trigger("change");
      });

      btnDown.click(function() {
        var oldValue = parseFloat(input.val());
        if (oldValue <= min) {
          var newVal = oldValue;
        } else {
          var newVal = oldValue - 1;
        }
        spinner.find("input").val(newVal);
        spinner.find("input").trigger("change");
      });

    });  
  
 //--------------------//   
setTimeout(function(){  	
    $(":radio").labelauty({
      label: false,
      icon: false
    });  
  },1000);
  
setTimeout(function(){  	
$( ".bold_option_radio" ).addClass( "loader-hide" );
  },1500);  
  
 setTimeout(function(){  	
$( ".vartions_product" ).addClass( "loader-hide" );
  },1500);  
});





$( document ).ready(function() {
  console.log($('div .h3').html())
  if(($('div .h3').html()=="Don't-Sweat Pants")){

$('div .h3').html('Fleece Pants')
}
});